import { TrainingLedger } from 'entities/training_ledger'
import { ViewModel } from 'view_models/view_model'

export class TrainingLedgerViewModel extends ViewModel<TrainingLedger> {}
